<ng-content></ng-content>
<app-icon *ngIf="!!accService.icon" class="accordion-head-icon" [src]="accService.icon" ></app-icon>